module.exports = __webpack_public_path__ + "img/dcAltFlow.4b00e127.gif";